<template>
  <div id="app">
    <h2>TLT INTERNATIONAL ENGINEERING TECHNOLOGY CO.,LTD</h2>
    <img style="height: 100px" src="../assets/bosch-logo.png" />

    <div class="check-container">
      <button
        class="btn btn-primary btn-check-data"
        :disabled="loading"
        @click="runCheck"
      >
        <i :class="loading ? 'fa fa-spinner fa-spin' : 'fa fa-clipboard-check'"></i>
        {{ loading ? 'Đang kiểm tra...' : 'Kiểm Tra Dữ Liệu' }}
      </button>

      <div v-if="reportHtml" class="report-card" ref="reportCard">
        <div class="report-body" v-html="reportHtml"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      loading: false,
      reportLines: [],
      reportHtml: "",
    };
  },
  methods: {
    async runCheck() {
      this.loading = true;
      this.reportLines = [];
      this.reportHtml = "";

      const baseUrl = process.env.VUE_APP_API_ENDPOINT;
      const url = baseUrl + "/api/v1/check-data";

      try {
        const response = await fetch(url, {
          headers: {
            Authorization: "Token " + this.getToken(),
          },
        });

        const reader = response.body.getReader();
        const decoder = new TextDecoder("utf-8");
        let buffer = "";
        let reading = true;

        while (reading) {
          const { done, value } = await reader.read(); // eslint-disable-line no-await-in-loop
          if (done) {
            reading = false;
            break;
          }

          buffer += decoder.decode(value, { stream: true });

          const parts = buffer.split("\n\n");
          buffer = parts.pop();

          for (const part of parts) {
            for (const rawLine of part.split("\n")) {
              if (!rawLine.startsWith("data: ")) continue;
              const line = rawLine.substring(6);
              if (line === "[DONE]") continue;
              this.reportLines.push(line);
            }
          }

          this.reportHtml = this.renderMarkdown(this.reportLines);
          this.$nextTick(() => this.scrollToBottom());
        }
      } catch (err) {
        this.reportLines.push("");
        this.reportLines.push("**Lỗi kết nối:** " + err.message);
        this.reportHtml = this.renderMarkdown(this.reportLines);
      }

      this.loading = false;
    },

    getToken() {
      const cookie = document.cookie;
      if (cookie.includes("Token")) {
        return cookie.split(";")[0].split("=")[1];
      }
      return "";
    },

    scrollToBottom() {
      const card = this.$refs.reportCard;
      if (card) {
        card.scrollTop = card.scrollHeight;
      }
    },

    renderMarkdown(lines) {
      let html = "";
      let inList = false;

      for (const line of lines) {
        if (line.startsWith("- ")) {
          if (!inList) {
            html += '<ul class="report-list">';
            inList = true;
          }
          html += "<li>" + this.inlineFormat(line.substring(2)) + "</li>";
          continue;
        }

        if (inList) {
          html += "</ul>";
          inList = false;
        }

        if (line === "---") {
          html += "<hr />";
        } else if (line.startsWith("# ")) {
          html += '<h3 class="report-h1">' + this.inlineFormat(line.substring(2)) + "</h3>";
        } else if (line.startsWith("## ")) {
          html += '<h4 class="report-h2">' + this.inlineFormat(line.substring(3)) + "</h4>";
        } else if (line === "") {
          html += '<div class="report-spacer"></div>';
        } else {
          html += '<p class="report-line">' + this.inlineFormat(line) + "</p>";
        }
      }

      if (inList) html += "</ul>";
      return html;
    },

    inlineFormat(text) {
      let s = text
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");

      s = s.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");
      s = s.replace(/`(.+?)`/g, '<code class="report-code">$1</code>');
      s = s.replace(/≠/g, "&ne;");

      return s;
    },
  },
};
</script>

<style scoped>
.check-container {
  margin-top: 30px;
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
}

.btn-check-data {
  font-size: 16px;
  padding: 10px 28px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.btn-check-data i {
  margin-right: 8px;
}

.report-card {
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  padding: 28px 32px;
  max-height: 70vh;
  overflow-y: auto;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  text-align: left;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: 15px;
  line-height: 1.7;
  color: #1a1a1a;
}

.report-card::-webkit-scrollbar {
  width: 6px;
}

.report-card::-webkit-scrollbar-thumb {
  background: #c0c0c0;
  border-radius: 3px;
}
</style>

<style>
.report-h1 {
  font-size: 20px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 4px 0;
  padding-bottom: 6px;
  border-bottom: 2px solid #e0e0e0;
}

.report-h2 {
  font-size: 17px;
  font-weight: 600;
  color: #2c3e50;
  margin: 16px 0 4px 0;
}

.report-line {
  margin: 2px 0;
}

.report-spacer {
  height: 8px;
}

.report-list {
  margin: 4px 0 4px 8px;
  padding-left: 16px;
}

.report-list li {
  margin-bottom: 3px;
  color: #c0392b;
  font-size: 14px;
}

.report-code {
  background: #f4f4f5;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 1px 5px;
  font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, monospace;
  font-size: 13px;
  color: #1a1a1a;
}

.report-card hr {
  border: none;
  border-top: 1px solid #e0e0e0;
  margin: 16px 0;
}

.report-card strong {
  color: inherit;
}
</style>
